// export enum types {
//   'middle-school',
//   'high-school',
// }

export const schoolTypes = {
  middle: 'ms',
  high: 'hs',
};
